<template>
    <div id="bezorgen" class="wrapper">
        <div class="inner-content">
            <Heading data-aos="fade-in" title="Bezorgen" subtitle="Wij doen ook aan thuis bezorgen"/>
            <p>
                Bij een bestelling vanaf <b>&euro;30,00</b> kunnen we ook de bestelling bij u laten thuisbezorgen.
                Voor een bezorging via de telefoon accepteren wij <b>alleen contant</b> geld. <br>
            </p>
            <br>
            <Heading data-aos="fade-in" subtitle="Online bestellen"/>
            <p>Voor online betalingen kunt u een bestelling plaatsen via Thuisbezorgd.</p>
            <a href="https://www.thuisbezorgd.nl/little-asia-rotterdam"
               class="badge"
               style="margin-top: 15px"
               target="_blank"
            >
                Online bestellen
            </a>
            <Heading data-aos="fade-in" subtitle="Postcodes waarin wij bezorgen:"/>
            <div class="zipcodes">
                <span class="badge" v-for="(zipcode, index) in zipcodes" :key="index">
                    {{zipcode}}
                </span>
            </div>
            <p>*Geef bij het maken van een telefonische bestelling uw adres gegevens en naam door.</p>
        </div>
    </div>
</template>

<script>
    import Heading from './sections/Heading'

    export default {
        name: 'Delivery',
        components: {
            Heading
        },
        data() {
            return {
                zipcodes: ['3032', '3033', '3035', '3036', '3037', '3038', '3039', '3041', '3045']
            }
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        padding: 4rem;
        text-align: center;
        background-color: rgb(255, 254, 245);
        // This for the footer
        margin-bottom: 440px;

        .inner-content {
            h1 {
                display: inline-block;
                margin-top: 0;
                color: #e74c3c;
                font-size: 4em;
            }

            p {
                font-size: 1.2em;
                margin: 0 auto;
                width: 50%;

                a {
                    color: black;
                }
            }

            .zipcodes {
                margin-top: 15px;
                margin-bottom: 20px;
            }

            .badge {
                background-color: #e74c3c;
                display: inline-block;
                margin-left: 10px;
                margin-top: 10px;
                color: white;
                padding: 10px;
                font-weight: bold;
                border-radius: 6px;
                text-align: center;
            }

        }
    }

    @media screen and (max-width: 600px) {
        .wrapper {
            padding: 0 0 50px 0;
            padding-top: 2em;
            margin-bottom: 500px;

            .inner-content {
                p {
                    width: 90%;
                }

            }
        }
    }
</style>

